module.exports = __webpack_public_path__ + "img/account_avatar.9419d57a.png";